<template>
  <div class="d-flex flex-column result-display">
    <div class="sortition-name">{{ result.sortition.name }}</div>
    <div class="sortition-date">{{ result.date }}</div>
    <v-row no-gutters>
      <v-col
        class="d-flex flex-xl-column align-center justify-space-around"
        xl="2">
        <div class="first" v-if="result.first">
          <h1 class="header">
            1st
          </h1>
          <result-digit-display :value="result.first"></result-digit-display>
        </div>
        <div class="second" v-if="result.second">
          <h1 class="header">
            2nd
          </h1>
          <result-digit-display :value="result.second"></result-digit-display>
        </div>
        <div class="third" v-if="result.third">
          <h1 class="header">
            3rd
          </h1>
          <result-digit-display :value="result.third"></result-digit-display>
        </div>
      </v-col>
      <v-col>
        <v-row no-gutters>
          <v-col md="6" lg="6" v-if="result.pickTwo">
            <v-row no-gutters>
              <v-col cols="12">
                <v-img height="50" contain :src="require('assets/static/img/picks/superlotto/pick2.png')" />
              </v-col>
              <v-col cols="12">
                <result-digit-display
                  class="d-flex justify-center"
                  :value="result.pickTwo"
                ></result-digit-display>
              </v-col>
            </v-row>
          </v-col>
          <v-col md="6" lg="6" v-if="result.cashThree">
            <v-row no-gutters>
              <v-col cols="12">
                <v-img height="50" contain :src="require('assets/static/img/picks/superlotto/pick3.png')" />
              </v-col>
              <v-col cols="12">
                <result-digit-display
                  class="d-flex justify-center"
                  :value="result.cashThree"
                ></result-digit-display>
              </v-col>
            </v-row>
          </v-col>
          <v-col lg="6" v-if="result.pickFour">
            <v-row no-gutters>
              <v-col cols="12">
                <v-img height="50" contain :src="require('assets/static/img/picks/superlotto/pick4.png')" />
              </v-col>
              <v-col cols="12">
                <result-digit-display
                  class="d-flex justify-center"
                  :value="result.pickFour"
                ></result-digit-display>
              </v-col>
            </v-row>
          </v-col>

          <v-col lg="6" v-if="result.pickFive">
            <v-row no-gutters>
              <v-col cols="12">
                <v-img height="50" contain :src="require('assets/static/img/picks/superlotto/pick5.png')" />
              </v-col>
              <v-col cols="11">
                <result-digit-display
                  class="d-flex justify-center"
                  :value="result.pickFive"
                ></result-digit-display>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import ResultDigitDisplay from "./ResultDigitDisplay.vue";

export default {
  name: "ResultDisplay",
  components: { ResultDigitDisplay },
  props: {
    result: {
      type: Object,
      required: true
    }
  }
};
</script>
<style scoped lang="scss">
.sortition-name {
	line-height: 18px;
	font-size: 1.3rem;
	font-weight: bold;
}

.sortition-date {
	font-size: 1.1rem;
}

.result-display {
	padding: 0;
}

.first,
.second,
.third {
	display: flex;
	flex-direction: column;
	margin: 5px 0;

	.header {
		margin-bottom: 3px;
		font-size: 1.3em;
	}
}
</style>
